import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const fetchNIPTransactionStatus = async () => {
  const response = await getData(ajaxEndpoints.FETCH_NIP_TRANSACTIONS_STATUS);
  return response?.data;
};

export const useFetchNIPTransactionStatus = () => {
  return useQuery("fetchNIPTransactionStatus", () =>
    fetchNIPTransactionStatus(),
  );
};
